import React from 'react'
import PanelMemberTemplate from '../../components/PanelMemberTemplate'
import { abu_data, Heidari_data } from '../../assets'

const Abu = () => {
  return (
    <>
    <PanelMemberTemplate {...abu_data}/>
    </>
  )
}

export default Abu